export const PXForms = (function() {
	'use strict';

	let $forms;

	function init() {
		events();
	}

	function renderForm() {
		$forms = $('.pxblock--forms');
		$forms.each( function() {
			let $this = $(this);
			let $container = $this.find('.pxblock--forms__container');
			let $textInputs = $this.find('input[type=text]:not(.datepicker), input[type=email], input[type=url], input[type=tel]');
			let $dateInputs = $this.find('input.datepicker');
			let $checkboxInputs = $this.find('.gfield_checkbox');
			let $textAreaInputs = $this.find('.textarea');
			let $fileInputs = $this.find('.ginput_container_fileupload');
			let $descriptions = $this.find('.gfield_description');
			let icon = PXConstants.theme_directory + '/assets/svg/question.svg';

			if($container.attr('data-style') === 'secondary') {
				let $fields = $container.find('.gform_fields');
				let gridRows = [];
				let gridAreas = [];
				
				// $secondaryFooter.appendTo($secondaryFields); 

				// $fields.children().each(function(index){
				// 	let childCount = index + 1;
				// 	if($fields.children().length === childCount) {
				// 		$( this ).css({
				// 			"grid-area" : "input-" + childCount,
				// 			// "grid-column" : "span 12" 
				// 		})
				// 		return;
				// 	}
				// 	// console.log($(this));
				// 	// $( this ).attr("style", index === 0 ? 'grid-area: input;' : 'grid-area: input-'+ index + " ;" );

				// 	// gridRows.push('1fr');
				// 	gridAreas.push( index === 0 ? 'input textarea' : 'input-'+ childCount +' textarea');
				// });

				// gridAreas.join("'' ''");
				
				// $fields.css({
				// 	// "grid-template-rows": "1fr",
				// 	"grid-template-rows": "'" + gridAreas.join("'' ''") + "'",
				// });
			}

			if($descriptions.length > 0){
				$descriptions.each(function(){
					let $description = $(this);
					// console.log($description);
					$description.wrap(function(){
						return '<div class="gfield_description__icon-group"></div>';
					}).parent().append( '<img alt="' + $(this).text() +'" src=' + icon + ' />');
				})
			}

			// File Input
			if($fileInputs.length > 0){
				$fileInputs.each(function(){
					let $fileInput = $(this);
					$fileInput
						.append('<div class="pxblock--forms__attach-file"><div class="pxblock--forms__attach-file-text">No file selected...</div><input type="button" value="Select File"/></div>')
						.closest('.gfield').addClass('pxblock--forms__file')
						.find('input[type=file]').bind('change', function() {
							let fileName = this.files[0].name;
							$fileInput.find('.pxblock--forms__attach-file-text').text(fileName);		
						});
				})
			}

			// Text
			$textInputs.closest('.gfield').addClass('pxblock--forms__text');
			
			// Date
			$dateInputs.closest('.gfield').addClass('pxblock--forms__date');

			// Checkbox
			$checkboxInputs.closest('.gfield').addClass('pxblock--forms__checkboxes');

			// Textarea
			$textAreaInputs.closest('.gfield').addClass('pxblock--forms__textarea');

			// Loaded
			$this.find('.gfield').addClass('pxblock--forms__loaded');

		});
	}

	function events() {
		$(document).bind('gform_post_render', function(){
			renderForm();
		});
	}

	return {
		init: init
	};
})();
